/* eslint-disable import/prefer-default-export */
import { tutorialsSlice } from '@Store/slices/tutorials';

export const { setCurrentVideo, setCurrentDocument } = tutorialsSlice.actions;
